// Which release channel this bundle is — baked in at build time from
// BUILD_TARGET (see releaseChannel.mjs / nuxt.config.ts runtimeConfig.public).
//
// Read this instead of sniffing `window.location.hostname`: a preview channel
// is served from the SAME host as production (Firebase hosting preview
// channels live under niceloop-pos-spa-v1--preview-test-*.web.app, and the
// beta build can be opened on localhost), so the hostname does not identify
// the channel reliably.

export type ReleaseChannel = 'production' | 'beta' | 'preview' | 'development'

export const useReleaseChannel = () => {
  const config = useRuntimeConfig().public

  const channel = ((config.releaseChannel as string) || 'development') as ReleaseChannel

  return {
    channel,
    isProduction: channel === 'production',
    isBeta: channel === 'beta',
    isPreview: channel === 'preview',
    // Doc ids are resolved at build time — never rebuild them on the client, or
    // the two halves can drift and a channel silently watches the wrong doc.
    // Fallbacks are the `_test` docs on purpose: if the build-time config ever
    // goes missing, a bundle must fail SAFE (talk to the dev channel) rather
    // than force-reload production.
    forceReloadDoc: (config.forceReloadDoc as string) || 'forceReload_test',
    announcementDoc: (config.announcementDoc as string) || 'announcement_test',
    homeMessageDoc: (config.homeMessageDoc as string) || 'home-message_test',
  }
}
